<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">
        <p>BerlinFuchs (engl: BerlinFox) is an initiative by Berlin based student <b>Britta Armstrong</b> to help
        handicapped people to find the place they need. The project is powered by
        <b>Google Maps</b> and shows locations like schools, work oportunities, appartments and
        free time/social activities.</p>

    </single-header>

    <!-- SECTION -->

    <single-section info header="Not yet finished" :color="project.color">

        <p>Due to lack of time the project is on ice right now.<br>
        Since the website is riddled with bugs I have disabled the link to it for now.</p>

    </single-section>

    <!-- SECTION -->

    <single-section header="What are you looking for?">

        <img src="assets/projects/berlinfuchs/menu.jpg" alt="Navigation Menu">

        <p>The menu holds 29 categories like kindergardens, work places separated for young and old
        but also areas with good accessibility for wheelchairs.</p>

        <video src="assets/projects/berlinfuchs/overlay-animation.mp4" autoplay loop></video>

    </single-section>

    <!-- SECTION -->

    <single-section header="Leads you all the way">

        <p>Type in your address or let the app find you with the help of GPS to show
        you the right way by car, foot, transit and bicycle.</p>

        <img src="assets/projects/berlinfuchs/directions.jpg" alt="Mobile View of the App">

    </single-section>

    <!-- SECTION -->

    <single-section header="Easy to navigate on mobile">

        <p>The map and direction navigation was inspired by the Google Maps website.
        Therefore it is tested and works well on mobile.</p>

        <img src="assets/projects/berlinfuchs/mobile.jpg" alt="Mobile View of the App">

    </single-section>


</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'

export default {
    data() {
        return {
            project: {
                title: 'BerlinFuchs',
                subtitle: 'Helps handicapped people to find their location in Berlin.',
                logoSuffix: 'png',
                background: 'url(assets/projects/berlinfuchs/project-header.jpg)',
                //background: '#df7b5f',
                color: '#df7b5f',
                role: 'Informative',
                features: 'WordPress, Google Maps, Vue',
                //url: 'https://berlinfuchs.artofmyself.com'
            }
        }
    },
    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// berlinfuchs.vue?cb46d962